export const techTopicsDictionary: Map<string, string> = new Map([
  ["fullstack", "Fullstack"],
  ["frontend", "Frontend"],
  ["backend", "Backend"],
  ["mobile", "Mobile"],
  ["typescript", "TypeScript"],
  ["javascript", "JavaScript"],
  ["react", "React"],
  ["redux", "Redux"],
  ["react-router", "React Router"],
  ["nodejs", "Node.js"],
  ["express", "Express"],
  ["mongodb", "MongoDB"],
  ["react-native", "React Native"],
  ["html", "HTML"],
  ["css", "CSS"],
  ["materialui", "Material UI"],
  ["styled-components", "Styled components"],
  ["graphql", "GraphQL"],
  ["nextjs", "Next.js"],
  ["api", "API"],
  ["figma", "Figma"],
  ["cms", "CMS"],
  ["monaco-editor", "Monaco Editor"],
  ["cli", "CLI"],
  ["npm", "npm"],
  ["esbuild", "esbuild"],
])
